module.exports = __webpack_public_path__ + "static/img/bn1.86766ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bn1.jpg
// module id = bJlh
// module chunks = 1